import React from "react";
import { Box } from "@mui/material";
import ProductsTable from "./ProductsTable.jsx";

const Product = ({ hideMainTitle = false }) => {
  return (
    <Box>
      <ProductsTable hideMainTitle={hideMainTitle} />
    </Box>
  );
};

export default Product;
